module.exports = __webpack_public_path__ + "static/media/Mock-Up-Application.75761128.png";